import {Injectable} from '@angular/core';
import {NavFactory} from './nav.factory';
import {NavItemCodes} from '../../enums/nav-item-codes.enum';
import {PermissionArea} from '../../enums/permission-area.enum';
import {IconCode} from '../../enums/icon-code.enum';
import {ExportXmlActions} from '../../state/export-xml/export-xml.actions';

@Injectable()
export class NavRootFactory extends NavFactory {
    protected static items = [
        {
            code: NavItemCodes.MANAGEMENT,
            icon: IconCode.MANAGEMENT,
            label: 'NAV.ADMIN.LABEL',
            description: 'NAV.ADMIN.DESC',
            path: '/admin',
            permissionArea: PermissionArea.MANAGEMENT,
            cy: 'management'
        },
        {
            code: NavItemCodes.HOME,
            icon: IconCode.HOME,
            label: 'NAV.HOME.LABEL',
            description: '',
            path: '/',
        },
        {
            code: NavItemCodes.START,
            icon: IconCode.START,
            label: '',
            description: '',
            path: '/start',
        },
        {
            code: NavItemCodes.EXPORT_XML,
            icon: IconCode.START,
            label: 'NAV.EXPORT_XML.LABEL',
            description: 'NAV.EXPORT_XML.DESC',
            action: new ExportXmlActions.OpenModal(),
            permissionArea: PermissionArea.PARTENON_MANAGEMENT
        }
    ];
}
